export default "__VITE_ASSET__rybkavUv__"